/**
 * Fallback location (Algiers) used until the browser provides GPS coordinates.
 * MUST stay identical between the client geolocation hook and any server-side
 * prefetch, so that geo-keyed query keys match across hydration.
 */
export const DEFAULT_COORDS = { latitude: 36.7538, longitude: 3.0588 } as const;
